import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=44823456&scoped=true&"
import script from "./FormItem.vue?vue&type=script&lang=ts&"
export * from "./FormItem.vue?vue&type=script&lang=ts&"
import style0 from "./FormItem.vue?vue&type=style&index=0&id=44823456&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44823456",
  null
  
)

export default component.exports